import React from 'react'
import styled from 'styled-components'
import Flickity from 'react-flickity-component'
import HeroSlide from './HeroSlide'
import { rem } from '../../styles/Mixins'
import { media } from 'styled-bootstrap-grid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons'
import { BannerBackground } from '../../assets/svgs'
import jump from 'jump.js'
import { withNullErrorBoundary } from '../../utils/withNullErrorBoundary'

export const HeroWrapper = styled.div`
  width: 100%;
  position: relative;
  z-index: 1;
  margin-bottom: 40px;
  min-height: 300px;

  ${media.xl`
    margin-top: -10px !important;
    min-height: 400px;
    min-height: calc(100vw / 2.8313);
    max-height: 620px;
  `}

  .flickity-enabled {
    position: relative;

    &.is-draggable {
      .is-selected {
        opacity: 1;
        z-index: 0;
      }
    }
  }

  .flickity-viewport {
    overflow: hidden;
    height: 400px;

    .slide {
      width: 100%;
      left: 0 !important;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      z-index: -1;
    }

    .flickity-slider {
      transform: none !important;
    }
  }

  :after {
    ${media.xl`
      content: '';
      position: absolute;
      right: -102px;
      bottom: -185px;
      z-index: 1;
      content: url(${BannerBackground});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: left center;
      transform: scale(0.8);
    `}

    @media(min-width: 1500px) {
      transform: none;
    }

    @media (min-width: 2500px) {
      display: none;
    }
  }

  ${media.lg`
    padding-bottom: 50px;
    margin-bottom: 0;
    max-width: 1920px;
    margin: 0 auto;
  `}
`

export const CarouselIndexWrapper = styled.div`
  display: flex;
  padding: 0 ${rem(20)};
  width: 100%;
  max-width: 500px;
  margin: 52px auto 0;

  ${media.md`
    margin-left: 0;
    padding-left: 40px;
  `}

  ${media.lg`
    position: absolute;
    z-index: 1;
    top: calc(100% - (30%));
    left: calc(100% - (46%));
    padding: 0;
    margin-left: 47px;
    max-width: 400px;
    margin-top: 0;
  `}

  ${media.xl`
    max-width: 400px;
  `}

  ${media.xxl`
    top: calc(100% - (32.5%));
  `}

  @media (min-width: 1600px) {
    max-width: 500px;
  }
`

export const CarouselIndexMarker = styled.div`
  font-family: 'foco_cc_italic', sans-serif;
  font-size: ${rem(13)};
  line-height: ${rem(16)};
  flex: 0 0 27%;
  color: ${(props) => props.theme.colors.grey};
  padding-top: 15px;
  position: relative;
  z-index: 1;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-right: 10%;

  &:last-child {
    margin-right: 0;
  }

  :after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 5px;
    background-color: ${(props) => props.theme.colors.grey_400};
    transition: all 0.2s ease-in-out;
  }

  :hover,
  &.is-selected {
    color: ${(props) => props.theme.colors.primary};

    :after {
      background-color: ${(props) => props.theme.colors.primary_light};
    }
  }

  ${media.xl`
    font-size: ${rem(17, 'xxxl')};
    padding-top: ${rem(27, 'xxxl')};
  `}
`

export const ScrollDownLinkWrapper = styled.div`
  text-align: center;
  display: none;

  ${media.lg`
    display: block;
    margin-top: 8px;
    position: absolute;
    bottom: 25px;
    z-index: 1;
    width: 100%;
    left: 0;
  `}
`

export const ScrollDownLink = styled.a`
  font-size: ${rem(12, 'xxxl')};
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
  position: relative;
  z-index: 1;
  padding-bottom: 15px;
  transition: all 0.2s ease-in-out;

  &.hidden {
    opacity: 0;
  }

  span {
    font-size: ${rem(15, 'xxxl')};
    color: ${(props) => props.theme.colors.secondary_dark};
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    transition: all 0.2s ease-in-out;

    svg {
      @media screen and (min-width: 0\0) {
        max-width: 10px;
        max-height: 15px;
      }
    }
  }

  :hover {
    span {
      bottom: -5px;
    }
  }
`

// const HeroInner = styled.div`
//   font-size: ${props => (props.large ? '20px' : '10px')};
// `;

// const fade =
//   typeof window !== 'undefined' ? require('flickity-fade') : () => null

const flickityOptions = {
  freeScroll: false,
  cellSelector: '.slide',
  contain: false,
  initialIndex: 0,
  accessibility: false,
  pageDots: false,
  wrapAround: false,
  prevNextButtons: false,
  fade: true,
  autoPlay: 6000,
  resize: true,
}

class HeroBanner extends React.Component {
  state = { currentSlide: 0 }
  constructor(props) {
    super(props)

    this.scrollRef = React.createRef()
  }

  updateScrollDown = () => {
    const windowScrollTop = window.pageYOffset
    // const scrollDownTop = this.scrollRef.current.getBoundingClientRect().top

    if (windowScrollTop > 100) {
      this.scrollRef.current.classList.add('hidden')
    } else {
      this.scrollRef.current.classList.remove('hidden')
    }
  }

  onScrollEvent = () => {
    window.requestAnimationFrame(this.updateScrollDown)
  }

  componentDidMount() {
    this.flkty.on('change', (index) => {
      this.setState({
        currentSlide: index,
      })
    })

    if (window) {
      window.addEventListener('scroll', this.onScrollEvent)
      window.addEventListener('resize', this.onScrollEvent)
      setTimeout(() => {
        this.onScrollEvent()
      }, 1000)
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('scroll', this.onScrollEvent)
      window.removeEventListener('resize', this.onScrollEvent)
    }
  }

  ScrollBottom() {
    jump('.services', {
      duration: 1000,
      offset: -1 * document.getElementById('main-header').offsetHeight,
      a11y: false,
    })
  }

  render() {
    return (
      <HeroWrapper>
        <Flickity
          options={flickityOptions}
          flickityRef={(ref) => (this.flkty = ref)}
          disableImagesLoaded={true}
        >
          {this?.props?.tabs?.map((props, i) => (
            <HeroSlide
              key={props?.tabIndexText}
              index={i}
              topContent={props?.aboveTitleText}
              bottomContent={props?.belowTitleText}
              imgSrc={props?.tabImage?.localFile?.childImageSharp?.fluid}
              title={props?.titleText}
              button={
                props.buttonLink && props.buttonText
                  ? {
                      text: props.buttonText,
                      url: props.buttonLink?.uri,
                    }
                  : null
              }
            />
          ))}
        </Flickity>
        {/* //Navigation */}
        <CarouselIndexWrapper>
          {this?.props?.tabs?.map((props, index) => (
            <CarouselIndexMarker
              key={props?.tabIndexText}
              className={this.state.currentSlide === index ? 'is-selected' : ''}
              onClick={() => {
                this.flkty.select(index, true)
              }}
            >
              {props?.tabIndexText}
            </CarouselIndexMarker>
          ))}
        </CarouselIndexWrapper>
        <ScrollDownLinkWrapper>
          <ScrollDownLink
            ref={this.scrollRef}
            href="#scrolldown"
            onClick={() => this.ScrollBottom()}
          >
            Scroll down
            <span>
              <FontAwesomeIcon icon={faAngleDown} />
            </span>
          </ScrollDownLink>
        </ScrollDownLinkWrapper>
      </HeroWrapper>
    )
  }
}

export default withNullErrorBoundary(HeroBanner)
